import { Outlet, useLocation, useMatch } from 'react-router-dom';
import { BannerSuporte } from '../master/BannerSuporte';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const BREADCRUMBS: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/eventos': 'Eventos',
  '/usuarios': 'Usuários',
  '/whatsapp': 'WhatsApp',
  '/auditoria': 'Auditoria',
  '/conta': 'Minha conta',
};

export function AppLayout() {
  const { pathname } = useLocation();

  // Rotas de evento têm id no caminho, então não batem no mapa fixo acima.
  const emParticipantes = useMatch('/eventos/:id/participantes');
  const emImportacao = useMatch('/eventos/:id/importar');
  const emConteudo = useMatch('/eventos/:id/conteudo');
  const emEvento = useMatch('/eventos/:id');

  const breadcrumb = emParticipantes
    ? 'Participantes'
    : emImportacao
      ? 'Importar participantes'
      : emConteudo
        ? 'Conteúdo do evento'
      : emEvento
        ? 'Evento'
        : (BREADCRUMBS[pathname] ?? 'Dashboard');

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-area">
        <BannerSuporte />
        <Topbar breadcrumb={breadcrumb} />
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
